// extracted by mini-css-extract-plugin
export default {"spinner":"i1JgwmQ5wcSyb3cZhJnR","rotating":"JR0zYC1JiYLTZv91A50w"};